import { Form, message, Steps, Space } from "antd";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { createAffiliate } from "@/lib/api/resources/affiliates";
import { useState } from "react";
import { AffiliateCreateDetailsStep } from "./components/steps/AffiliateCreateDetailsStep";
import { AffiliateCreateSlugStep } from "./components/steps/AffiliateCreateSlugStep";
import { AffiliateCreateNextStep } from "./components/steps/AffiliateCreateNextStep";
import { Button, Card } from "@rumbledirect/ui";

export const AffiliateCreate = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);

  const mutation = useMutation({
    mutationFn: createAffiliate,
    onSuccess: () => {
      setCurrent(2);
    },
    onError: () => message.error("Aanmaken mislukt"),
  });

  const goNext = async () => {
    try {
      if (current === 0) {
        await form.validateFields(["name", "email"]);
        setCurrent(1);
      } else if (current === 1) {
        await form.validateFields(["slug"]);
        const values = form.getFieldsValue(["name", "email", "slug"]);
        /* TODO: Remove fallback value when ormDatabaseDsn is optional */
        mutation.mutate({ ormDatabaseDsn: "NULL", ...values });
      }
    } catch {}
  };

  const goPrev = () => setCurrent((c) => Math.max(0, c - 1));

  const steps = [
    { key: "details", title: "Gegevens" },
    { key: "slug", title: "Slug & database" },
    { key: "next", title: "Volgende stappen" },
  ];

  const renderStep = () => {
    if (current === 0) return <AffiliateCreateDetailsStep />;
    if (current === 1)
      return (
        <AffiliateCreateSlugStep form={form} loading={mutation.isPending} />
      );
    if (current === 2) return <AffiliateCreateNextStep form={form} />;
    return null;
  };

  return (
    <div className="w-full flex justify-center">
      <Card className="max-w-4xl w-full" title="Nieuwe affiliate">
        <Steps current={current} items={steps} style={{ marginBottom: 24 }} />
        <Form form={form} layout="vertical" disabled={mutation.isPending}>
          {renderStep()}
          <Space style={{ marginTop: 24 }}>
            {current === 1 && (
              <Button onClick={goPrev} disabled={mutation.isPending}>
                Vorige
              </Button>
            )}
            {current < 2 && (
              <Button
                type="primary"
                onClick={goNext}
                disabled={mutation.isPending}
                loading={mutation.isPending && current === 1}
              >
                {current === 1 ? "Aanmaken" : "Volgende"}
              </Button>
            )}
            {current === 2 && (
              <Button type="primary" onClick={() => navigate("/affiliates")}>
                Terug naar overzicht
              </Button>
            )}
          </Space>
        </Form>
      </Card>
    </div>
  );
};
